import { render } from "./Footer.vue?vue&type=template&id=08bc1d1c"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/less-mess/less-mess/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__